export default __webpack_public_path__ + "static/portfolio-f62ddd45a848b7201794fd78652a5e2b.pdf";